export type User = {
  id: string
  email: string
  name?: string | null
  phone?: string | null
  address?: string | null
  role?: 'SUPER_ADMIN' | 'OWNER' | 'BUYER' | 'CUSTOMER'
  emailVerifiedAt?: string | null
  provider?: string | null
}
export type SignupPayload = { name?: string; email: string; password: string }

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || ''

async function request<T>(path: string, opts: RequestInit = {}) {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
      cache: 'no-store',
      ...opts,
    })
    const ct = res.headers.get('content-type') || ''
    const body = ct.includes('application/json') ? await res.json().catch(() => ({})) : await res.text()
    return { ok: res.ok, status: res.status, body: body as T }
  } catch {
    return { ok: false, status: 0, body: {} as T }
  }
}

export async function getMe() {
  return request<{ user: User | null }>('/api/auth/me')
}

export async function login(email: string, password: string) {
  return request<{ ok: true; error?: string }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
}

export async function signup(payload: SignupPayload) {
  return request<{ ok: true; error?: string }>('/api/auth/signup', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function logout() {
  return request<{ ok: true }>('/api/auth/logout', { method: 'POST' })
}

export async function forgotPassword(email: string) {
  return request<{ ok: true }>('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
}

export async function resetPassword(token: string, password: string) {
  return request<{ ok: true; error?: string }>('/api/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  })
}
